import React from 'react';
import SpoofBoldEot from './spoof/spoof-bold.eot';
import SpoofMediumEot from './spoof/spoof-medium.eot';
import SpoofRegularEot from './spoof/spoof-regular.eot';
import SpoofBoldWoff from './spoof/spoof-bold.woff';
import SpoofMediumWoff from './spoof/spoof-medium.woff';
import SpoofRegularWoff from './spoof/spoof-regular.woff';
import SpoofBoldWoff2 from './spoof/spoof-bold.woff2';
import SpoofMediumWoff2 from './spoof/spoof-medium.woff2';
import SpoofRegularWoff2 from './spoof/spoof-regular.woff2';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getPreloadMetas = function getPreloadMetas() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("link", {
      rel: "preload",
      href: SpoofBoldWoff2,
      as: "font",
      type: "font/woff2",
      crossOrigin: "true"
    }), /*#__PURE__*/_jsx("link", {
      rel: "preload",
      href: SpoofMediumWoff2,
      as: "font",
      type: "font/woff2",
      crossOrigin: "true"
    }), /*#__PURE__*/_jsx("link", {
      rel: "preload",
      href: SpoofRegularWoff2,
      as: "font",
      type: "font/woff2",
      crossOrigin: "true"
    })]
  });
};
export default "\n    @font-face {\n    font-family: 'Spoof';\n    src: url(".concat(SpoofRegularEot, ");\n    src: url(").concat(SpoofRegularEot, "?#iefix) format('embedded-opentype'),\n    url(").concat(SpoofRegularWoff2, ") format('woff2'),\n    url(").concat(SpoofRegularWoff, ") format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n    text-rendering: optimizeLegibility;\n  }\n\n  @font-face {\n    font-family: 'Spoof';\n    src: url(").concat(SpoofBoldEot, ");\n    src: url(").concat(SpoofBoldEot, "?#iefix) format('embedded-opentype'),\n    url(").concat(SpoofBoldWoff2, ") format('woff2'),\n    url(").concat(SpoofBoldWoff, ") format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n    text-rendering: optimizeLegibility;\n  }\n\n  @font-face {\n    font-family: 'Spoof';\n    src: url(").concat(SpoofMediumEot, ");\n    src: url(").concat(SpoofMediumEot, "?#iefix) format('embedded-opentype'),\n    url(").concat(SpoofMediumWoff2, ") format('woff2'),\n    url(").concat(SpoofMediumWoff, ") format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n    text-rendering: optimizeLegibility;\n  }\n");